import { render, staticRenderFns } from "./SiteDescription.vue?vue&type=template&id=fe212ede&scoped=true&"
import script from "./SiteDescription.vue?vue&type=script&lang=js&"
export * from "./SiteDescription.vue?vue&type=script&lang=js&"
import style0 from "./SiteDescription.vue?vue&type=style&index=0&id=fe212ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe212ede",
  null
  
)

export default component.exports